import React from 'react';
import { useDispatch } from 'react-redux';

import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  styled,
  Typography,
} from '@mui/material';

import { Resource } from '../../../common/constants/resource';
import { summaryListActions } from '../../tasks/slice/aiSummaryListSlice';
import { PromptType } from '../../tasks/types/taskTypes';
import styles from '../styles.module.scss';

export default function Accurate({
  evidenceId,
  promptType,
  like,
}: {
  evidenceId?: number;
  promptType: PromptType;
  like?: boolean;
}) {
  const dispatch = useDispatch();

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      summaryListActions.updateLike({
        evidenceId,
        promptType,
        like: event.target.value === 'true',
      }),
    );
  };

  return (
    <div>
      <FormControl component="fieldset">
        <Box display="flex" flexDirection="row" className={styles.aiContainer}>
          <Typography className={styles.formLabel}>
            {Resource.ACCURATE_QUESTION}
          </Typography>

          <RadioGroup
            value={like?.toString()}
            onChange={handleOptionChange}
            row
          >
            <FormControlLabel
              value={'true'}
              control={<CustomRadio />}
              label="Yes"
            />
            <FormControlLabel
              value={'false'}
              control={<CustomRadio />}
              label="No"
            />
          </RadioGroup>
        </Box>
      </FormControl>
    </div>
  );
}

const CustomRadio = styled(Radio)(() => ({
  color: 'black',
  '&.Mui-checked': {
    color: 'black',
  },
}));
